/**
 * FontAwesome icon grid section component
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FAIconSection = React.memo(({ category, icons, onSelect, currentValue, color, colorValue }) => (
  <div className="ip-section">
    <div className="ip-section__header">{category}</div>
    <div className="ip-section__grid ip-section__grid--icons">
      {icons.map((item, i) => (
        <button
          key={i}
          className={`ip-btn ip-btn--icon ${currentValue === item.name ? 'ip-btn--selected' : ''}`}
          style={{ color }}
          onClick={() => onSelect({ 
            type: 'fontawesome', 
            value: item.name,
            color: colorValue 
          })}
          title={item.displayName}
        >
          <FontAwesomeIcon icon={item.icon} />
        </button>
      ))}
    </div>
  </div>
));

FAIconSection.displayName = 'FAIconSection';

export default FAIconSection;

